<template>
  <div class="edit-platform">
    <div class="breadcrumb" style="background: #fff">详情</div>
    <div class="order-detail-basic">
      <div style="margin-right: 20px;">订单列表:</div>
      <el-table ref="multipleTable" :data="tableData" fit border :row-class-name="rowClassName" @selection-change="handleSelectionChange">
        <!-- <el-table-column v-show="settlement" type="selection" width="55"></el-table-column> -->
        <el-table-column prop="orderNo" label="订单号" min-width="150px"></el-table-column>
        <el-table-column prop="priceTotal" label="会员总价" min-width="100px"></el-table-column>
        <el-table-column prop="priceReal" label="实付总价 " min-width="100px"></el-table-column>
        <el-table-column prop="settlementAmount" label="结算价"></el-table-column>
      </el-table>
    </div>
    <div class="edit-button">
      <div v-if="settlementStatus !== 'REJECTED'">
        <el-button round style="width: 100px" @click="checkType = false, checkDialog = true" v-if="$hasPermission('oms:admin:orderSettlement:aduit')">拒绝结算</el-button>
        <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="checkType = true, checkDialog = true" v-if="$hasPermission('oms:admin:orderSettlement:aduit')">结算</el-button>
      </div>
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="$router.go(-1)" v-else>返回</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="checkDialog" width="30%">
      <span>{{ checkType ? '是否确认结算？' : '是否确认拒绝结算？' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialog = false">取 消</el-button>
        <el-button type="primary" @click="check">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { handleCashout } from '@/api/epay'
import { getSettlement, settlementBatchAudit } from '@/api/oms'
export default {
  name: 'audit',
  data () {
    return {
      settlementStatus: 'REJECTED',
      checkDialog: false,
      tableData: [],
      storeMsg: {},
      settlementId: ''
    }
  },
  created () {
    let id = this.$route.query.id
    this.getDetailList(id)
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    async getDetailList (id) {
      await getSettlement(id).then(res => {
        if (res.data.success) {
          this.settlementId = res.data.data.id
          this.tableData = res.data.data.orders
          this.settlementStatus = res.data.data.settlementStatus
        }
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    async check () {
      // console.log(this.basicInfo)
      let auditInfo
      if (this.checkType) {
        auditInfo = {
          auditStatus: 'AUDITED'
        }
      } else {
        auditInfo = {
          auditStatus: 'REJECTED'
        }
      }
      let settlementIds = []
      settlementIds.push(this.settlementId)
      console.log('settlementIds', settlementIds)
      await settlementBatchAudit(auditInfo, settlementIds).then(res => {
        if (res.data.success) {
          if (this.checkType) {
            this.$message.success('结算成功')
          } else {
            this.$message.success('拒绝结算成功')
          }
          this.checkDialog = false
          this.$router.go(-1)
        }
      })
    },
    back () {
      this.$router.go(-1)
    },
    invoice () {
      let auditVo = {
        action: 'invoice',
        refundId: this.basicInfo.refundId
      }
      handleCashout(auditVo).then(res => {
        if (res.data.success) {
          this.$message.success('操作成功')
          this.$router.go(-1)
        }
      })
    },
    cashout () {
      let auditVo = {
        action: 'cashout',
        refundId: this.basicInfo.refundId
      }
      handleCashout(auditVo).then(res => {
        if (res.data.success) {
          this.$message.success('操作成功')
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@deep: ~">>>";

.order-detail-basic {
  display: flex;
  width: 60%;
  margin-left: 15%;
}
</style>
